import useApiMutation from 'shared/hooks/use-api-mutation';
import useToken from '../atoms/use-token';
import useQueryHelpers from 'shared/hooks/use-query-helpers';

const useRegister = () => {
  const {setToken} = useToken();
  const {setData} = useQueryHelpers();

  const onSuccess = ({token, ...data}: any) => {
    setToken(token);
    setData('/users/me', data);
  };

  return useApiMutation({
    url: '/auth/register',
    method: 'POST',
    errorTitle: 'Erro ao criar conta',
    onSuccess,
  });
};
export default useRegister;
